import { fetchFfdJson } from 'shared/api/ffdClient';
import { PriceSummary } from 'features/price-summary/state/priceSummaryAtoms';

interface PriceSummaryApiResponse {
  text?: string;
  body?: {
    accountId?: string;
    currency?: string | null;
    fiscalYearToDateAmount?: string;
    currentMonthToDateAmount?: string;
  };
}

export interface FetchPriceSummaryResult {
  summary: PriceSummary | null;
  errorMessage: string;
}

const parsePriceSummary = (body?: PriceSummaryApiResponse['body']): PriceSummary | null => {
  if (!body) return null;

  const {
    accountId,
    currency,
    fiscalYearToDateAmount,
    currentMonthToDateAmount,
  } = body;

  if (
    typeof accountId !== 'string' ||
    typeof fiscalYearToDateAmount !== 'string' ||
    typeof currentMonthToDateAmount !== 'string'
  ) {
    return null;
  }

  return {
    accountId,
    currency: typeof currency === 'string' && currency !== '' ? currency : 'N/A',
    fiscalYearToDateAmount,
    currentMonthToDateAmount,
  };
};

export const fetchPriceSummary = async (authToken: string): Promise<FetchPriceSummaryResult> => {
  try {
    const { response, data } = await fetchFfdJson<PriceSummaryApiResponse>('/price/summary', authToken);

    if (!response.ok) {
      return {
        summary: null,
        errorMessage: data.text ?? `使用料金サマリの取得に失敗しました。(HTTP ${response.status})`,
      };
    }

    const summary = parsePriceSummary(data.body);
    if (!summary) {
      return {
        summary: null,
        errorMessage: '使用料金サマリのレスポンス形式が不正です。',
      };
    }

    return {
      summary,
      errorMessage: '',
    };
  } catch (_error) {
    return {
      summary: null,
      errorMessage: '使用料金サマリの取得に失敗しました。',
    };
  }
};
